import React from 'react'
import PropTypes from 'prop-types'
import glamorous from 'glamorous'

const Button = glamorous.button('vx_btn', {
  width: '270px',
  height: '48px',
  borderRadius: '50px',
  border: '2px solid #0070ba',
  padding: '0',
  margin: '0',
  display: 'block',
  '@media only screen and (max-width: 768px)': {
    fontSize: '14px',
    width: '271px',
    maxWidth: '350px',
    height: '36px',
    margin: 0,
    borderWidth: '1px',
    fontWeight: '500',
  },
})

class PPDGButton extends React.Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    handleClick: PropTypes.func,
    pageName: PropTypes.string,
  }

  render() {
    const { text, type, handleClick, pageName } = this.props

    return (
      <Button
        className={`vx_btn-${type}`}
        onClick={handleClick}
        data-pagename={pageName}
      >
        {text}
      </Button>
    )
  }
}

export default PPDGButton
